module.exports = __webpack_public_path__ + "static/media/boxx.8073992c.png";